import Backbone from 'backbone';
import { AppConfig } from '@ve/types';

declare const $: any;
interface ExWindow extends Window {
    appConfig: AppConfig
}

declare let window: ExWindow;

export default (tourCriteria: Backbone.Model): void => {
    const checkInDateRange = tourCriteria.get('checkInDateRange');
    const dateFrom = (checkInDateRange && checkInDateRange.get && checkInDateRange.get('from') && $ && $.datepicker)
        ? $.datepicker.formatDate('dd.mm.yy', checkInDateRange.get('from'))
        : '';

    const countries = tourCriteria.get('countries');
    const firstCountry = (countries && countries.length) ? countries.at(0) : null;
    const toCountry = firstCountry ? firstCountry.get('name') : '';

    const title = `${toCountry} ${dateFrom ? `c ${dateFrom}` : ''}`;

    const { showcaseTitle } = window.appConfig;
    const result = showcaseTitle ? `${title} | ${showcaseTitle}` : title;
    document.title = result;
    window.appConfig.dynamicTitle = result;
};